import { NgModule, ModuleWithProviders  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { EzoCaptchaComponent } from './ezo-captcha.component';
import {EzoCaptchaService} from './ezo-captcha.service';


@NgModule({
  declarations: [EzoCaptchaComponent],
  exports:[EzoCaptchaComponent],
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class EzoCaptchaModule { 
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: EzoCaptchaModule,
      providers: [ EzoCaptchaService ]
    };
  }
}